import '../lib/readingtime.js';

$(() => {
	$('.js-read-article').readingTime({
		readingTimeTarget: $('.time-to-read > .ttr-target'),
		lessThanAMinuteString: '1 min',
		wordsPerMinute: 200
	})
})
